var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    notification: true,
    loading: _vm.timer,
    fail: _vm.notification && _vm.notification.type === 'fail',
    success: _vm.notification && _vm.notification.type === 'success'
  }},[_c('div',{staticClass:"notification--inner"},[_c('p',{domProps:{"textContent":_vm._s(_vm.notification.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }